export default "__VITE_ASSET__43bb94cd__"